tryBabble = require './try-babble'
assert = require './assert'

module.exports = (keyPath, formatArgs, options) ->
  result = tryBabble(keyPath, formatArgs, options)
  assert(typeof result == 'string', "babble: key #{keyPath} not found")
  result
